import styled from 'styled-components';

export const EdBody = styled.div`
  margin: 0 30px 30px 30px;
  min-width: 900px;

  &:first-of-type {
    margin-top: 30px;
  }
  @media (max-width: 950px) {
    min-width: 0px;
    width: auto;
  }
`;

export const EdBodyFormMid = styled.div`
  justify-content: space-between;
  padding: 0 40px 20px 30px;
  display: flex;
`;

export const EdBodyFormMidWrapper = styled.div`
  width: 100%;
`;

export const EdFooter = styled.div`
  border-top: 1px solid var(--LightGray);
  justify-content: end;
  align-items: center;
  padding: 30px 30px;
  margin-top: 20px;
  min-width: 292px;
  display: flex;
  flex-wrap: wrap;
`;

export const EdCancelFooter = styled.div`
  justify-content: flex-end;
  display: flex;
  padding: 10px 0;
`;
